import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
// import { FormattedMessage } from 'react-intl'
import { Td, Row } from '@layout/ParticipantsTable';
import { ToggleArrow, Participant } from '@molecules';

class ParticipantsTableRow extends PureComponent {
  static propTypes = {
    expandedId: PropTypes.number,
    setField: PropTypes.func,
    arrayItemId: PropTypes.number,
    email: PropTypes.string,
    country: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.number,
    userId: PropTypes.number,
    phoneNumber: PropTypes.string,
    timezone: PropTypes.string,
    type: PropTypes.string,
  };

  toggleSummary = () => {
    const { userId, expandedId, setField } = this.props;

    if (expandedId === userId) {
      setField('expandedId', null);
      return;
    }
    setField('expandedId', userId);
  };

  render() {
    const { country, name, phoneNumber, type, expandedId, userId } = this.props;
    const expanded = !!(expandedId === userId);

    return (
      <Fragment key={userId}>
        <Row key={userId} background expanded={expanded} onClick={this.toggleSummary}>
          <Td padding="1rem" background className="dashboard-row-toggle">
            <ToggleArrow expanded={expanded} />
          </Td>
          <Td padding="1rem" background className="participants-row-name">
            {name}
          </Td>
          <Td padding="1rem" background className="participants-row-type">
            {type}
          </Td>
          <Td padding="1rem" background className="participants-row-phoneNumber">
            {phoneNumber}
          </Td>
          <Td padding="1rem" background className="participants-row-country">
            {country}
          </Td>
        </Row>
        {expanded && (
          <Row background>
            <Td padding="1rem" background className="participant-details" colSpan={7}>
              <Participant {...this.props} />
            </Td>
          </Row>
        )}
      </Fragment>
    );
  }
}

export default ParticipantsTableRow;



// WEBPACK FOOTER //
// ./components/organisms/ParticipantsTable/ParticipantsTableRow.js